import { Graphics } from "pixi.js";
import { circleRadius } from "../config";
import { fade, grow } from "./animations";

export class Circle extends Graphics {
  color: number;
  radius: number;
  constructor({
    y,
    x,
    color,
    radius = circleRadius,
  }: {
    y: number;
    x: number;
    color: number;
    radius?: number;
  }) {
    super();
    this.color = color;
    this.radius = radius;
    this.drawShapes();
    this.x = x;
    this.y = y;
  }

  private drawShapes() {
    const glowAlpha = 0.04;
    // Soft outer glow rings
    this.circle(0, 0, this.radius * 2.2).fill({
      color: this.color,
      alpha: glowAlpha,
    }).blendMode = "add";
    this.circle(0, 0, this.radius * 1.8).fill({
      color: this.color,
      alpha: glowAlpha,
    }).blendMode = "screen";
    this.circle(0, 0, this.radius * 1.4).fill({
      color: this.color,
      alpha: glowAlpha,
    }).blendMode = "multiply";
    // Main fill
    this.circle(0, 0, this.radius).fill(this.color);
    // Inner highlight – small white dot offset top-left for a shiny/lit look
    this.circle(
      -this.radius * 0.22,
      -this.radius * 0.27,
      this.radius * 0.22,
    ).fill({ color: 0xffffff, alpha: 0.1 }).blendMode = "screen";
  }

  redraw = () => {
    this.clear();
    this.drawShapes();
  };

  appear = (alpha: number = 0.8) =>
    Promise.all([fade(this, undefined, alpha), grow(this, 1)]);
  disappear = (size?: number) => Promise.all([fade(this), grow(this, size)]);
}

export default Circle;
